// src/pages/battle/components/ActionControls.jsx
import React from 'react';
import { Move, Target, Wand2 } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';
import { canUseAbility } from '../../../utils/skillSystem';
import { formatAbilityInfo } from '../Battlemap.utils';

const ActionControls = ({
  selectedUnit,
  setSelectedUnit,
  mode,
  setMode,
  selectedAbility,
  setSelectedAbility,
  handleAbilitySelect,
  primaryColor,
  alertColor
}) => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg p-4">
      <h3 className="font-bold mb-3 text-sm text-gray-400">SELECTED UNIT</h3>
      <p className="font-bold mb-4">{selectedUnit.name}</p>
      
      <div className="space-y-2">
        <button 
          onClick={() => { 
            setMode('move'); 
            setSelectedAbility(null); 
          }}
          className={`w-full flex items-center gap-2 px-4 py-3 rounded font-bold transition-all ${
            mode === 'move' 
              ? getColorClasses(primaryColor, 'bgMain') 
              : 'bg-gray-700 hover:bg-gray-600'
          }`}
        >
          <Move size={20} /> 
          <div className="flex-1 text-left">
            <div>MOVE</div>
            <div className="text-xs opacity-75">({selectedUnit.ap} AP)</div>
          </div>
        </button>
        
        <button 
          onClick={() => { 
            setMode('shoot'); 
            setSelectedAbility(null); 
          }}
          disabled={selectedUnit.ap < 1}
          className={`w-full flex items-center gap-2 px-4 py-3 rounded font-bold transition-all ${
            mode === 'shoot' 
              ? getColorClasses(alertColor, 'bgMain') 
              : 'bg-gray-700 hover:bg-gray-600'
          } ${selectedUnit.ap < 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <Target size={20} /> 
          <div className="flex-1 text-left">
            <div>SHOOT</div>
            <div className="text-xs opacity-75">(1 AP)</div>
          </div>
        </button>

        <button
          onClick={() => setSelectedUnit(null)}
          className="w-full bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded font-bold text-sm transition-all mt-4"
        >
          DESELECT
        </button>
      </div>

      {/* Abilities Section */}
      {selectedUnit.abilities && selectedUnit.abilities.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-700">
          <h4 className="font-bold text-xs text-gray-400 mb-2">ABILITIES</h4>
          <div className="space-y-2">
            {selectedUnit.abilities.map(ability => {
              const canUse = canUseAbility(selectedUnit, ability, selectedUnit.ap).canUse;
              const isSelected = selectedAbility?.id === ability.id;
              
              return (
                <button
                  key={ability.id}
                  onClick={() => handleAbilitySelect(ability)}
                  disabled={!canUse}
                  className={`w-full text-left px-3 py-2 rounded text-sm transition-all ${
                    isSelected 
                      ? getColorClasses(primaryColor, 'bgMain')
                      : canUse
                      ? 'bg-purple-900 hover:bg-purple-800'
                      : 'bg-gray-700 opacity-50 cursor-not-allowed'
                  }`}
                  title={ability.description}
                >
                  <div className="flex items-center gap-2">
                    <Wand2 size={14} />
                    <div className="flex-1 min-w-0">
                      <div className="font-bold truncate">{ability.name}</div>
                      <div className="text-xs opacity-75 truncate">
                        {formatAbilityInfo(ability)}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionControls;